import type { ApolloCache } from "@apollo/client/cache"

import { ProjectTypename } from "shared/types/Project"

import {
  ProjectCompleteFragment,
  ProjectCompleteFragmentDoc,
  ProjectFragment,
  ProjectFragmentDoc
} from "entities/projects/graphql/fragments.generated"

export function readProjectFragment(id: string, cache: ApolloCache<object>) {
  if (!cache.identify({ id, __typename: ProjectTypename })) {
    return null
  }
  return cache.readFragment<ProjectFragment>(
    {
      id: cache.identify({ id, __typename: ProjectTypename }),
      fragmentName: "Project",
      fragment: ProjectFragmentDoc
    },
    true
  )
}

export function readProjectCompleteFragment(
  id: string,
  cache: ApolloCache<object>
) {
  if (!cache.identify({ id, __typename: ProjectTypename })) {
    return null
  }

  return cache.readFragment<ProjectCompleteFragment>(
    {
      id: cache.identify({ id, __typename: ProjectTypename }),
      fragmentName: "ProjectComplete",
      fragment: ProjectCompleteFragmentDoc
    },
    true
  )
}
